// ── THEME ──────────────────────────────────────────────────────────────────
export const GOLD    = '#C9A84C';
export const SILVER  = '#A8B8C8';
export const DARK_BG = '#0A0C0E';
export const CARD_BG = '#111418';
export const BORDER  = '#1E2530';
export const TEXT    = '#F0EDE8';
export const MUTED   = '#8A9BB0';
export const GREEN   = '#22C55E';
export const RED     = '#EF4444';
export const PURPLE  = '#8B5CF6';
export const CYAN    = '#06B6D4';
export const ORANGE  = '#F97316';

export const CHART_COLORS = [GOLD, SILVER, GREEN, RED, PURPLE, CYAN, ORANGE, '#EC4899'];

// ── BUSINESS CONSTANTS ─────────────────────────────────────────────────────
export const METAL_TYPES      = ['Gold', 'Silver', 'Platinum', 'Palladium'];
export const ITEM_CATEGORIES  = [
  'Gold Coin', 'Silver Coin', 'Platinum Coin', 'Palladium Coin',
  'Gold Bar', 'Silver Bar', 'Platinum Bar', 'Palladium Bar',
  'Gold Jewelry', 'Silver Jewelry', 'Platinum Jewelry',
  'Numismatic/Collectible', 'Currency / Paper', 'Scrap Metal', 'Other',
];
export const CHANNELS    = ['Retail', 'Wholesale'];
export const DIRECTIONS  = ['Purchase', 'Sale'];
export const GRADE_SVCS  = ['Raw', 'PCGS', 'NGC', 'ANACS', 'ICG', 'Other'];
export const PAYMENT_METHODS  = ['', 'Cash', 'Zelle', 'Venmo', 'Wire', 'Check', 'Credit Card', 'Crypto', 'Other'];
